import { FILE_UPLOAD_CALL, FILE_UPLOAD_URL_CALL } from '@instructure/quiz-common';
import contentDisposition from 'content-disposition';
import Fetcher from '../util/Fetcher';
export function getUploadUrl(url) {
  var urlFetcher = new Fetcher({
    callType: FILE_UPLOAD_URL_CALL
  });
  return urlFetcher.get(url);
}

// This fxn requires a secondary fxn as an argument.
// It gets the url to post the file to S3 from the request and returns a promise.
export var sendFileToS3 = function sendFileToS3(file, onSuccess, onError, altText) {
  var fileFetcher = new Fetcher({
    asyncResponseHandler: function asyncResponseHandler() {},
    callType: FILE_UPLOAD_CALL,
    headers: {
      'Content-Type': file.type,
      // This thing handles unicode filenames appropriately for HTTP headers - yay
      'Content-Disposition': contentDisposition(file.name)
    },
    onError: onError
  });
  return function (res) {
    // After uploading, the signed portion of the URL is useless and incorrect
    var s3url = res.url.split(/[?#]/)[0];
    return fileFetcher.put("".concat(res.url), {
      body: file
    }).then(function (ref) {
      onSuccess(s3url, altText);
    });
  };
};